import React from "react";
import { useIntl } from "react-intl";

function PromotionsTypeRenderer({ entity, field }) {
  const intl = useIntl();
  const { discountPeriodicity } = entity;
  let value = entity[field && field.fieldName];
  value = value && value.replace("-", "");
  const day = intl.formatMessage({ id: "default.day" });
  if (discountPeriodicity) {
    value = `${discountPeriodicity.applyEveryNumberOfUnits}x${
      discountPeriodicity.applyEveryNumberOfUnits - discountPeriodicity.discountedUnits
    }`;
  } else if (value && value[0] === "0") {
    value = intl.formatMessage({ id: "default.highlight" });
  } else if (!value.includes("%")) {
    value = `${value}€/${day}`;
  }
  return <>{value}</>;
}

export default PromotionsTypeRenderer;
